/**
 * 一次 Web 运行内的编排任务去重。Redux store 在整页加载时重新创建，
 * React 重挂载、SPA 导航和前后台切换继续使用同一个 owner。
 * 不读写登录凭证、旧 sessionStorage 标记或其它业务的频控记录。
 */
const usedKeys = new WeakMap<object, Set<string>>();

export const isSessionOnceUsed = (key: string, owner: object): boolean =>
  usedKeys.get(owner)?.has(key) ?? false;

export const markSessionOnceUsed = (key: string, owner: object): void => {
  let keys = usedKeys.get(owner);
  if (!keys) {
    keys = new Set();
    usedKeys.set(owner, keys);
  }
  keys.add(key);
};

export const clearAllSessionOnceKeys = (owner: object): void => {
  usedKeys.delete(owner);
};
